/* Profit On Your Terms's home, /poyt (POYT.dc.html's "Paid in full" Tweak at 1440). No board draws it
   on a phone or in the widths between, so there it takes PhoneWeek.dc.html's and PhoneLibrary.dc.html's
   pieces: 16px gutters, cards with 14px corners, smaller headings, buttons the whole width, the
   board's order stacked. It sits inside the product frame's .pp--poyt look (product.css), which sets
   the page, the gutter and the footer, and uses its hero (the place secured page's). Colours are the
   tokens file's only: navy, orange, paper and ink, Archivo and IBM Plex Sans. */

/* The hero sits right under the menu, the full width of the page, as the board draws it, whatever
   the frame puts at the top of the page (the read-only line, the payment banner, the welcome
   checklist): those follow it, so the course's dates lead the page. Then the board's main: 36px
   under the hero, 28px between sections. */
.pp .pp-area:has(> .py-hero) { --pp-area-top: 36px; --pp-area-gap: 28px; }
.pp-area > .py-hero { order: -1; margin: calc(-1 * var(--pp-area-top)) calc(-1 * var(--pp-gutter)) 8px; }

.py-home { display: flex; flex-direction: column; min-width: 0; }
.py-home--loading { min-height: 50vh; }
.pp .py-home-layout { gap: 28px; }
.py-home-layout .pp-band { gap: 24px; }
.py-home-layout .pp-band-col { gap: 24px; }
/* the scripts guarantee and the deal surgery are the same height, side by side */
.py-home-layout .pp-band:has([data-section='surgery']) { align-items: stretch; }
.py-home-layout .pp-band:has([data-section='surgery']) .pp-band-col > .pp-section:only-child { flex: 1; display: flex; flex-direction: column; }
.py-home-layout .pp-band:has([data-section='surgery']) .pp-band-col > .pp-section:only-child > section { flex: 1; }

/* Join on Zoom, on the night, in the hero's card: the board's orange button (the tool card's) */
.py-join {
  height: 46px; border-radius: 10px; background: var(--poyt-orange-2); font-weight: 600; font-size: 15px;
  display: flex; align-items: center; justify-content: center; gap: 8px; text-decoration: none;
}
.pp .py-join { color: var(--on-dark); }

/* The cards */
.py-card { border-radius: 16px; background: var(--pp-card); border: 1px solid var(--pp-rule); overflow: hidden; min-width: 0; }
.py-card--pad { padding: 26px 28px; display: flex; flex-direction: column; gap: 8px; }
.py-card-head {
  padding: 24px 28px; display: flex; align-items: baseline; justify-content: space-between; gap: 16px 24px;
  border-bottom: 1px solid var(--pp-rule);
}
.py-h2 { margin: 0; font-family: var(--poyt-heading-font); font-weight: 800; font-size: 26px; letter-spacing: -0.01em; }
.py-h3 { margin: 0; font-family: var(--poyt-heading-font); font-weight: 700; font-size: 19px; }
.py-h3--big { font-size: 20px; }
.py-text { margin: 0; font-size: 15px; line-height: 1.6; color: var(--pp-soft); }
.pp .py-mail { color: inherit; text-decoration: underline; text-underline-offset: 2px; }
.pp .py-mail:hover { color: var(--poyt-ink); }
.py-msg { margin: 0; font-size: 14px; line-height: 1.5; color: var(--pp-ink); }

/* The buttons: navy, or outlined once done */
.py-btn {
  flex-shrink: 0; height: 42px; padding: 0 18px; border-radius: 10px; border: 1px solid var(--poyt-navy);
  background: var(--poyt-navy); font-weight: 600; font-size: 14px; display: inline-flex; align-items: center;
  justify-content: center; text-decoration: none; white-space: nowrap;
}
.pp .py-btn { color: var(--on-dark); }
.pp .py-btn--line { background: var(--pp-card); border-color: var(--poyt-done-line); color: var(--poyt-navy); }
.pp .py-btn--quiet { border-color: var(--poyt-navy); }
.py-btn[aria-busy='true'] { cursor: progress; }

/* Start here */
.py-count { font-size: 15px; font-weight: 600; color: var(--poyt-orange); white-space: nowrap; }
.py-step { display: flex; gap: 20px; padding: 24px 28px; border-bottom: 1px solid var(--pp-rule-soft); align-items: flex-start; }
.py-disc {
  width: 40px; height: 40px; border-radius: 20px; flex-shrink: 0; display: flex; align-items: center; justify-content: center;
  font-family: var(--poyt-heading-font); font-weight: 800; font-size: 17px;
  background: var(--pp-card); color: var(--poyt-navy); border: 1.5px solid var(--poyt-done-line);
}
.py-disc--done { background: var(--poyt-orange); color: var(--on-dark); border-color: var(--poyt-orange); }
.py-step-text { flex: 1 1 auto; display: flex; flex-direction: column; gap: 6px; min-width: 0; }
.py-step-title { margin: 0; font-family: var(--poyt-heading-font); font-weight: 700; font-size: 19px; }
.py-step-body { margin: 0; font-size: 15px; line-height: 1.6; color: var(--pp-soft); }
.py-step-wait {
  flex-shrink: 0; height: 42px; display: flex; align-items: center; gap: 8px;
  font-size: 13px; font-weight: 500; color: var(--pp-soft); white-space: nowrap;
}
.py-start-foot { margin: 0; padding: 18px 28px 22px; font-size: 14px; line-height: 1.6; color: var(--pp-soft); }

/* The tool card */
.py-tool {
  padding: 28px; border-radius: 16px; background: var(--poyt-navy); color: var(--on-dark);
  display: flex; flex-direction: column; gap: 12px; min-width: 0;
}
.py-tool-eyebrow { font-size: 12px; font-weight: 600; letter-spacing: 0.16em; text-transform: uppercase; color: var(--poyt-soft-on-navy); }
.py-tool-title { margin: 0; font-family: var(--poyt-heading-font); font-weight: 800; font-size: 24px; }
.py-tool-line { margin: 0; font-size: 15px; line-height: 1.6; color: var(--on-dark-86); }
.py-tool-btn {
  align-self: flex-start; height: 44px; padding: 0 18px; margin-top: 4px; border-radius: 10px; border: none;
  background: var(--poyt-orange-2); font-weight: 600; font-size: 15px; display: flex; align-items: center; text-decoration: none;
}
.pp .py-tool-btn { color: var(--on-dark); }
.py-tool-btn:focus-visible { outline-color: var(--on-dark); }

/* Your 6 weeks */
.py-head-note { font-size: 14px; color: var(--pp-soft); text-align: right; }
.py-wk-list { list-style: none; margin: 0; padding: 0; }
.py-wk {
  position: relative; display: grid; grid-template-columns: 96px 150px minmax(0, 1fr) 210px; gap: 20px;
  align-items: center; padding: 18px 28px; border-bottom: 1px solid var(--pp-rule-soft);
}
.py-wk--open:hover { background: color-mix(in srgb, var(--poyt-paper) 50%, var(--pp-card)); }
.py-wk-label {
  font-family: var(--poyt-heading-font); font-weight: 800; font-size: 15px; letter-spacing: 0.06em;
  text-transform: uppercase; color: var(--poyt-navy);
}
.py-wk--current .py-wk-label { color: var(--poyt-orange); }
.py-wk-date { font-size: 14px; color: var(--pp-soft); }
.py-wk-main { display: flex; flex-direction: column; gap: 4px; min-width: 0; }
.py-wk-title { font-family: var(--poyt-heading-font); font-weight: 700; font-size: 17px; }
.pp .py-wk-link { color: var(--poyt-ink); text-decoration: none; }
/* an open week: the whole row opens it */
.py-wk-link::after { content: ''; position: absolute; inset: 0; }
.py-wk-link:hover { text-decoration: underline; text-underline-offset: 3px; }
.py-wk-pack { font-size: 13px; line-height: 1.5; color: var(--pp-soft); }
.py-wk-status {
  justify-self: end; display: flex; align-items: center; gap: 8px; font-size: 13px; font-weight: 500;
  color: var(--pp-soft); text-align: right;
}
.py-wk--next .py-wk-status, .py-wk--live .py-wk-status { color: var(--poyt-orange); }
.py-wk--live .py-wk-status { font-weight: 600; }
.py-wk--done .py-wk-status, .py-wk--carry .py-wk-status { color: var(--poyt-ink); }
.py-wk--done .py-wk-status .icon-line { color: var(--poyt-orange); }
/* each week's recording frame in front of its row, once any recording has a thumbnail (decision 47) */
.py-wk-list--thumbs .py-wk { grid-template-columns: 112px 96px 140px minmax(0, 1fr) 190px; }
.py-wk-thumb { --rthumb-radius: 8px; }
.py-wk-thumb .rthumb-date { font-size: 10px; }
.py-wk-thumb .rthumb-day { font-size: 18px; }

/* The scripts guarantee and the deal surgery */
.py-guarantee, .py-surgery { padding: 28px; gap: 10px; }
.py-guarantee-link { font-size: 15px; font-weight: 600; text-decoration: none; }
.pp .py-guarantee-link { color: var(--poyt-orange); }
.pp .py-guarantee-link:hover { color: var(--poyt-ink); text-decoration: underline; }
.py-surgery-btn { align-self: flex-start; margin-top: 4px; }

/* Between a laptop and a phone: every section in 1 column, in the layout's order (Layout.jsx) */
@media (max-width: 1099px) {
  .py-hero .pp-hero-h1 { font-size: 48px; }
  .py-wk { grid-template-columns: 80px 128px minmax(0, 1fr) 170px; gap: 16px; }
  .py-wk-list--thumbs .py-wk { grid-template-columns: 96px 72px 120px minmax(0, 1fr) 150px; }
}
/* where the countdown card would squeeze the heading, it goes under it */
@media (max-width: 940px) {
  .py-hero { flex-direction: column; align-items: stretch; gap: 28px; }
  .py-hero .pp-hero-card { width: auto; max-width: 440px; }
}

/* A phone (PhoneWeek.dc.html and PhoneLibrary.dc.html's pieces) */
@media (max-width: 760px) {
  .pp-area > .py-hero { margin: -22px -16px 0; }
  .py-hero .pp-hero-h1 { font-size: 38px; }
  .pp .py-home-layout { gap: 22px; }
  .py-card, .py-tool { border-radius: 14px; }
  .py-card--pad, .py-guarantee, .py-surgery { padding: 20px 16px; }
  .py-card-head { padding: 18px 16px; flex-direction: column; align-items: flex-start; gap: 6px; }
  .py-h2 { font-size: 24px; }
  .py-head-note { text-align: left; }
  .py-step { padding: 18px 16px; gap: 14px; flex-wrap: wrap; }
  .py-disc { width: 34px; height: 34px; border-radius: 17px; font-size: 15px; }
  .py-step-text { flex: 1 1 calc(100% - 48px); }
  .py-step-title { font-size: 18px; }
  .py-step-btn, .py-step-wait { flex: 1 1 100%; }
  .py-step-wait { height: auto; white-space: normal; padding-left: 48px; }
  .py-start-foot { padding: 14px 16px 18px; }
  .py-tool { padding: 22px 16px; }
  .py-tool-btn { align-self: stretch; justify-content: center; height: 46px; }
  .py-surgery-btn { align-self: stretch; height: 46px; white-space: normal; text-align: center; }
  .py-wk {
    grid-template-columns: minmax(0, 1fr) auto; grid-template-areas: 'label date' 'main main' 'status status';
    gap: 6px 12px; padding: 16px;
  }
  .py-wk-label { grid-area: label; }
  .py-wk-date { grid-area: date; text-align: right; font-size: 13px; }
  .py-wk-main { grid-area: main; }
  .py-wk-status { grid-area: status; justify-self: start; text-align: left; }
  .py-wk-list--thumbs .py-wk {
    grid-template-columns: 88px minmax(0, 1fr) auto; grid-template-areas: 'thumb label date' 'thumb main main' 'thumb status status';
  }
  .py-wk-thumb { grid-area: thumb; align-self: start; --rthumb-radius: 6px; }
  .py-wk-thumb .rthumb-day { font-size: 16px; }
}
